import React from 'react';
import { useLang } from '../i18n/LangContext';
import { AMENITY_KEYS } from '../data/content';
import { Wifi, Flame, ChefHat, Trees, Car, UtensilsCrossed } from 'lucide-react';

const ICONS = {
  wifi: Wifi,
  fireplace: Flame,
  kitchen: ChefHat,
  garden: Trees,
  parking: Car,
  bbq: UtensilsCrossed,
};

export default function Amenities() {
  const { t } = useLang();
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
      {AMENITY_KEYS.map((k) => {
        const Icon = ICONS[k];
        return (
          <div
            key={k}
            className="flex flex-col items-start gap-4 p-5 md:p-6 rounded-xl bg-white border border-[#EAE4DA] hover:border-[#C9BC98] transition-colors"
          >
            <div className="h-11 w-11 rounded-full bg-[#EFEBDF] flex items-center justify-center text-[#606F51]">
              <Icon size={20} strokeWidth={1.6} />
            </div>
            <span className="text-[#2C2A26] text-sm md:text-base font-medium leading-snug">
              {t.amenities.items[k]}
            </span>
          </div>
        );
      })}
    </div>
  );
}
